export default function SpacerBlock({ data }) {
  const size = data?.size || "md";
  const h = size === "sm" ? "h-8" : size === "lg" ? "h-32" : "h-16";
  return <div className={h} aria-hidden="true" />;
}
